var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66005 6.72071C4.46747 8.15133 3.75 9.99188 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C14.0081 20.25 15.8487 19.5325 17.2793 18.34L5.66005 6.72071ZM6.72071 5.66005L18.34 17.2793C19.5325 15.8487 20.25 14.0081 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C9.99188 3.75 8.15133 4.46747 6.72071 5.66005ZM18.8953 18.8933C20.6591 17.129 21.75 14.6919 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C14.6915 21.75 17.1283 20.6594 18.8926 18.896C18.8931 18.8954 18.8937 18.8949 18.8943 18.8943",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/Stop.91f1a92372ea4db4fe453331de1b29dc.svg";
export { ForwardRef as ReactComponent };